var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 10.0003V9.87535H2H0.301754L9.38039 0.795733L9.38044 0.795688C9.54456 0.631383 9.76727 0.539062 9.9995 0.539062C10.2317 0.539062 10.4544 0.631383 10.6186 0.795688L10.6186 0.795738L19.6982 9.87535H18H17.875V10.0003V18.0003C17.875 18.4836 17.4832 18.8753 17 18.8753H3C2.51675 18.8753 2.125 18.4836 2.125 18.0003V10.0003ZM8.125 17.0003V12.1253H11.875V17.0003V17.1253H12H16H16.125V17.0003V8.82835V8.77657L16.0884 8.73996L10.0884 2.73996L10 2.65157L9.91161 2.73996L3.91161 8.73996L3.875 8.77657V8.82835V17.0003V17.1253H4H8H8.125V17.0003Z",
    fill: "#676767",
    stroke: "white",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.87a8b55f11c3c48c513e448a1bfc466f.svg";
export { ForwardRef as ReactComponent };